import type { TypeLinkDetailed } from 'types/autogen/contentful';
import type { PageActionModel } from 'components/shared/Routing/PageAction';

export function navigationLinkToPageAction(navigationLink?: TypeLinkDetailed | undefined): PageActionModel | undefined {
    if (!navigationLink) return undefined;

    if (navigationLink.fields.linkToItem && typeof navigationLink.fields.linkToItem === 'object')
        return navigationLink.fields.linkToItem as unknown as PageActionModel;

    if (navigationLink.fields.slug && typeof navigationLink.fields.slug === 'object')
        return navigationLink.fields.slug as unknown as PageActionModel;

    if (navigationLink.fields.externalUrl && typeof navigationLink.fields.externalUrl === 'object')
        return navigationLink.fields.externalUrl as unknown as PageActionModel;

    if (
        navigationLink.fields.linkToFile &&
        typeof navigationLink.fields.linkToFile === 'object' &&
        navigationLink.fields.linkToFile.fields.file?.url
    ) {
        return {
            action: {
                url: navigationLink.fields.linkToFile.fields.file?.url,
                noFollow: false,
                openInNewWindow: true,
                $type: 'ExternalLinkAction'
            },
            $type: 'LinkActionType'
        } as PageActionModel;
    }

    return undefined;
}
